import { useState } from "react";

export type LoginFormProps = {
  pending: boolean;
  error: string | null;
  onSignIn: (email: string, password: string) => void;
  onSignUp: (email: string, password: string, name: string) => void;
};

/**
 * Presentational sign-in/sign-up form. Deliberately takes plain callback
 * props rather than talking to authClient directly, so render/gating
 * behavior is testable without mocking better-auth's network layer.
 */
export function LoginForm({ pending, error, onSignIn, onSignUp }: LoginFormProps) {
  const [mode, setMode] = useState<"sign-in" | "sign-up">("sign-in");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (mode === "sign-in") {
      onSignIn(email, password);
    } else {
      onSignUp(email, password, name);
    }
  }

  return (
    <div className="login-screen">
      <h1>peek</h1>
      <p>Sign in to see your fleet.</p>
      <form onSubmit={handleSubmit}>
        {mode === "sign-up" && (
          <label>
            Name
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoComplete="name"
              required
            />
          </label>
        )}
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
        </label>
        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={mode === "sign-in" ? "current-password" : "new-password"}
            minLength={8}
            required
          />
        </label>
        {error && (
          <p role="alert" className="login-error">
            {error}
          </p>
        )}
        <button type="submit" disabled={pending}>
          {pending ? "Working…" : mode === "sign-in" ? "Sign in" : "Sign up"}
        </button>
      </form>
      <button
        type="button"
        className="login-mode-toggle"
        onClick={() => setMode(mode === "sign-in" ? "sign-up" : "sign-in")}
      >
        {mode === "sign-in" ? "Need an account? Sign up" : "Have an account? Sign in"}
      </button>
    </div>
  );
}
